import { Autocomplete, TextField } from "@mui/material";
import "./autoCompleteComponent.scss";
import ArrowDropDownIcon from "svg-icons/arrow-dropdown-icon";
// import { useSelector } from "react-redux";

const AutoCompleteComponent = ({item = [], handelChange}) => {
  // const top100Films = [
  //   { label: "The Shawshank Redemption"},
  //   { label: "The Godfather"},
  //   { label: "The Godfather: Part II", year: 1974 },
  //   { label: "The Dark Knight", year: 2008 },
  //   { label: "12 Angry Men", year: 1957 },
  //   { label: "Schindler's List", year: 1993 },
  //   { label: "Pulp Fiction", year: 1994 },
  // ];
  
  // const dir = useSelector(({ theme }) => theme.direction);

  return (
    <div className="auto-complete-component">
      <Autocomplete
        onInputChange={(event, inputValue)=>{
          document.getElementById('combo-box-demo').style.opacity = '1';
          handelChange(inputValue)
        }}
        disablePortal
        autoComplete
        id="combo-box-demo"
        options={item}
        className="textfield-item"
        disableClearable={true}
        forcePopupIcon={false}
        popupIcon={<ArrowDropDownIcon width="30px" height="25px" color="#0986ed" />}
        renderInput={(params) => <TextField he {...params} />}
      />
    </div>
  );
};

export default AutoCompleteComponent;
